import { Redirect } from 'react-router-dom';
import { ROUTES } from 'routing';
import { useUser } from 'shared/hooks';
import { determineIsAdmin } from 'shared/utility';
import { UserMappingCreatePage } from './user-mapping-create-page';

export function UserMappingCreatePageResolver() {
  const user = useUser();

  if (!user) {
    return null;
  }

  const isAdmin = determineIsAdmin(user);
  if (!isAdmin) {
    return <Redirect to={ROUTES.products} />;
  }

  return <UserMappingCreatePage user={user} />;
}
